export const DEFAULT_GROUP = {
    id: Symbol('DEFAULT_GROUP_ID'),
    name: 'DEFAULT_GROUP_NAME',
};
